import type { Config } from "tailwindcss";
import plugin from "tailwindcss/plugin";
import { CUSTOM_COLORS, CUSTOM_COMPONENTS, CUSTOM_SHADOW } from "./themeConfig";

const config: Config = {
  corePlugins: {
    preflight: false,
  },
  content: [],
  theme: {
    data: {
      dragging: 'ui~="dragging"',
    },
    extend: {
      transitionProperty: {
        height: "height",
      },
      colors: CUSTOM_COLORS,
      backgroundImage: {
        "gradient-radial": "radial-gradient(var(--tw-gradient-stops))",
        "gradient-conic":
          "conic-gradient(from 180deg at 50% 50%, var(--tw-gradient-stops))",
      },
      fontFamily: {
        inter: ["Inter", "sans-serif"],
      },
      flexGrow: {
        2: "2",
      },
      boxShadow: CUSTOM_SHADOW,
      padding: {
        18: "72px",
      },
      height: {
        "150%": "150%",
      },
      width: {
        "150%": "150%",
      },
      keyframes: {
        fadeIn: {
          "0%": { opacity: "0" },
          "100%": { opacity: "1" },
        },
        bottomToTop: {
          "0%": { bottom: "-600px" },
          "100%": { bottom: "0px" },
        },
        bounceFromRest: {
          "50%": {
            transform: "translateY(-25%)",
            "animation-timing-function": "cubic-bezier(0.8,0,1,1)",
          },
          "0%, 100%": {
            transform: "none",
            "animation-timing-function": "cubic-bezier(0,0,0.2,1)",
          },
        },
      },
      animation: {
        fadeIn: "fadeIn 400ms ease-in-out 1",
        bottomToTop: "bottomToTop 300ms ease-in 1",
        bounceFromRest: "bounceFromRest 1000ms ease-in-out infinite",
      },
    },
  },
  plugins: [
    plugin(({ addComponents }) => {
      addComponents(CUSTOM_COMPONENTS);
    }),
  ],
};
export default config;
